import { useFormik } from 'formik';
import { useEffect } from 'react';
import { PqrStrategicAlly } from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';

export const usePqrStrategicAlly = (strategicAlly?: PqrStrategicAlly) => {
    const formik = useFormik({
        initialValues: {
            strategicAlly: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            strategicAlly: useGetNameOrValue(
                strategicAlly?.strategicAlly || 'N/A'
            ),
        });
    }, [strategicAlly]);

    return {
        formik,
    };
};
